module.exports = __webpack_public_path__ + "img/20200514_144534.0dc36ec7.jpg";